import { Box, ClickAwayListener } from '@mui/material';
import {
  GridColumnsPanel,
  GridFilterPanel,
  GridToolbarContainer,
  GridToolbarContainerProps,
  useGridApiContext,
} from '@mui/x-data-grid-premium';
import { RiAlertLine, RiFilter3Line, RiLayoutColumnLine } from '@remixicon/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import type { KeyboardEvent } from 'react';
import { FC, ReactNode } from 'react';
import CountIcon from 'src/components/atoms/CountIcon';
import { MenuDropDown } from 'src/components/atoms/MenuDropDown';

export type ToolbarProps = {
  children?: ReactNode;
  Buttons?: FC;
  BeforeButtons?: FC;
  searchBoxSlot?: ReactNode;
  onFilterClickedAway?: () => void;
} & GridToolbarContainerProps;

export default function Toolbar({
  children,
  Buttons,
  BeforeButtons,
  searchBoxSlot = <Box sx={{ flexGrow: 1 }} />,
  onFilterClickedAway = () => {},
  sx = {},
  ...props
}: ToolbarProps) {
  const flags = useFlags();
  const apiRef = useGridApiContext();
  const filters = apiRef.current?.state?.filter?.filterModel?.items?.length;

  return (
    <GridToolbarContainer
      {...props}
      sx={{ gap: 2, display: 'flex', pb: 1.5, ...sx, '@media print': { display: 'none' }, px: 0 }}
    >
      {searchBoxSlot}
      <Box sx={{ display: 'flex', gap: 1, height: '40px', alignItems: 'center' }}>
        {BeforeButtons && <BeforeButtons />}

        <MenuDropDown icon={<CountIcon count={filters} Icon={RiFilter3Line} />} hint="Filter rows">
          <ClickAwayListener onClickAway={onFilterClickedAway}>
            <GridFilterPanel
              filterFormProps={{
                valueInputProps: {
                  onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
                    e.stopPropagation();
                  },
                },
              }}
            />
          </ClickAwayListener>
        </MenuDropDown>
        {flags.orderFlagging && (
          <MenuDropDown icon={<RiAlertLine className="h-5 w-5" />} hint="Show flagged orders">
            warning
          </MenuDropDown>
        )}
        <MenuDropDown icon={<RiLayoutColumnLine className="h-5 w-5" />} hint="Show/Hide columns">
          <GridColumnsPanel sx={{ '& .MuiDataGrid-columnsPanelRow:has(>.Mui-disabled)': { display: 'none' } }} />
        </MenuDropDown>
        {Buttons && <Buttons />}
      </Box>
      {children}
    </GridToolbarContainer>
  );
}
